import React from "react";
import i18n from "../i18n";
import {ApiResponseError, apiResponseErrorCodes} from "../utils/api";
import FileChooseButton from "./FileChooseButton";

export default class ErrorView extends React.Component {
  state = {
    timeStart: 0,
    timeLeft: 0,
    timeLeftProgress: 0,
    message: "",
  };

  componentDidMount() {
    this.setState({timeStart: Date.now()});

    const isProcessingTimeoutError = this.props.error && this.props.error.type === "processing_timeout";
    const isPhotolabError = this.props.error && this.props.error.type === "photolab";
    const isPhotolabSystemError = isPhotolabError && this.props.error.code > -1000;

    let message = i18n.t("error__default_message");
    let buttonWithTimer = false;

    if (isPhotolabSystemError || isProcessingTimeoutError) {
      message = i18n.t("error_overload");
      buttonWithTimer = true;
    } else if (isPhotolabError) {
      message = this.props.error.message;
    } else if (this.props.error instanceof ApiResponseError
      && this.props.error.code === apiResponseErrorCodes.FILE_FORMAT_INVALID)
    {
      message = i18n.t("error__api_code_415");
    }

    this.setState({message});

    if (buttonWithTimer) {
      this.timer = setInterval(() => {
        const timeoutMs = window.appConfig.processings.errorButtonTimeout;
        const timeLeft = Math.max(0, (this.state.timeStart + timeoutMs) - Date.now());
        const timeLeftProgress = (timeoutMs - timeLeft) / timeoutMs;
        this.setState({timeLeft, timeLeftProgress});
      }, 1000/60);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  formatMillisToTime = (millis) => {
    const seconds = ("0" + Math.floor(millis / 1000)).slice(-2);
    const minutes = ("0" + Math.floor(seconds / 60)).slice(-2);

    return `${minutes}:${seconds}`;
  };

  render() {
    const isPhotolabError = this.props.error && this.props.error.type === "photolab";

    let buttonText = isPhotolabError ? i18n.t("btn_try_another_photo") : i18n.t("btn_choose_photo");
    if (this.state.timeLeft > 0) {
      buttonText = i18n.t("time_next_try", {
        time: this.formatMillisToTime(this.state.timeLeft),
      });
    }

    return <main className="error-page">
      <div className="container">
        <div className="error-content">
          <ErrorSVG />
          <p>{this.state.message}</p>
        </div>
        {!this.props.hideUploadForm && <FileChooseButton
          disabled={this.state.timeLeft > 0}
          onFileSelected={this.props.onFileSelected}
          className="btn-upload-foto"
          children={buttonText}
          progress={this.state.timeLeftProgress}
          progressContent={buttonText} />}
        <button
          className="btn-upload-foto btn-upload-foto-full"
          onClick={this.props.onStartOver}>
          {i18n.t("btn_start_again")}
        </button>
      </div>
    </main>;
  }
}

function ErrorSVG() {
  return <svg width="114" height="102" viewBox="0 0 114 102" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M72.852 20.682c-1.059 0-2.123.042-3.178.123a10.473 10.473 0 0 1-6.617-3.369 10.594 10.594 0 0 1-1.134-1.488 8.138 8.138 0 0 0 3.398-1.835 8.032 8.032 0 0 0 2.67-5.607 8.02 8.02 0 0 0-2.103-5.84A8.126 8.126 0 0 0 60.245.013c-7.23-.36-13.473 6.728-13.923 15.786-.08 1.621.027 3.23.32 4.784.032.176.062.344.09.508a41.638 41.638 0 0 0-5.813-.41C18.356 20.682 0 38.919 0 61.335s18.355 40.653 40.918 40.653c2.84 0 5.676-.291 8.43-.864.024-.005.047-.013.07-.019 2.775.582 5.63.883 8.531.883 2.388 0 4.757-.209 7.082-.615.1.041.204.076.314.1 2.075.459 3.493.528 5.14.528.337 0 .683-.003 1.047-.006.408-.003.844-.007 1.32-.007 22.561 0 40.917-18.236 40.917-40.652 0-22.417-18.355-40.653-40.918-40.653zm-22.758-4.698c.34-6.837 4.62-12.23 9.624-12.23.113 0 .227.002.34.008a4.363 4.363 0 0 1 3.031 1.424 4.307 4.307 0 0 1 1.129 3.136c-.104 2.094-1.69 3.775-3.698 4.086a10.46 10.46 0 0 1-.177-2.51A1.88 1.88 0 0 0 58.55 7.93a1.884 1.884 0 0 0-1.98 1.782 14.068 14.068 0 0 0 3.688 10.243 14.275 14.275 0 0 0 4.623 3.377c-.961.241-2.09.404-3.383.404-3.16 0-7.332-.187-9.566-.712-.542-.128-1.18-.396-1.296-1.348a28.28 28.28 0 0 0-.282-1.782 16.73 16.73 0 0 1-.26-3.911zm25.201 82.169a40.839 40.839 0 0 0 9.293-5.96c.792-.676.882-1.86.203-2.647a1.897 1.897 0 0 0-2.663-.2 37.28 37.28 0 0 1-24.178 8.888c-9.921 0-19.248-3.838-26.264-10.807a1.897 1.897 0 0 0-2.67 0 1.868 1.868 0 0 0 0 2.653 40.943 40.943 0 0 0 11.712 8.152C20.335 98.13 3.777 81.618 3.777 61.334c0-20.294 16.576-36.813 36.983-36.898a40.938 40.938 0 0 0-12.035 8.444c-.73.74-.718 1.928.027 2.653.367.358.845.536 1.322.536.49 0 .979-.188 1.349-.562a37.1 37.1 0 0 1 17.337-9.93 5.74 5.74 0 0 0 2.3 1.099c3.211.755 8.8.814 10.437.814 3.04 0 5.421-.731 7.104-1.516a37.179 37.179 0 0 1 15.873 9.533c.37.375.86.563 1.35.563.476 0 .954-.178 1.321-.537a1.868 1.868 0 0 0 .027-2.653 41.005 41.005 0 0 0-11.866-8.363c19.339 1.26 34.686 17.29 34.686 36.818 0 19.53-15.352 35.563-34.697 36.818z" fill="#fff"/>
    <path d="M19.584 53.93a1.884 1.884 0 0 0-2.137 1.591 40.87 40.87 0 0 0-.416 5.813c0 1.036.846 1.877 1.889 1.877 1.043 0 1.888-.84 1.888-1.877 0-1.768.127-3.545.377-5.28a1.879 1.879 0 0 0-1.601-2.124zM96.95 56.65c-1.044 0-1.89.84-1.89 1.876a37.16 37.16 0 0 1-.392 5.39 1.878 1.878 0 0 0 1.87 2.148c.922 0 1.73-.671 1.867-1.605.287-1.953.433-3.949.433-5.933a1.883 1.883 0 0 0-1.889-1.876zM52.867 41.001c-.222-1.144-.685-3.524-2.738-4.023-1.784-.433-3.164 1.05-3.905 1.846-.982 1.057-1.705 2.046-2.403 3.002-1.154 1.58-2.15 2.943-4.14 4.315-2.295 1.583-3.838 2.418-4.965 3.028-1.359.735-2.34 1.266-3.265 2.372-.916 1.096-2.172 2.598-1.898 4.674.405 3.076 3.802 4.467 4.834 4.82.936.32 1.907.48 2.913.48 2.53 0 5.276-1.013 8.195-3.031 4.889-3.38 6.39-8.206 6.956-10.025.345-1.111 1.076-4.062.416-7.458zm-4.163 6.294c-.498 1.602-1.664 5.352-5.44 7.962-2.998 2.072-5.558 2.767-7.607 2.066-.991-.34-2.144-1.088-2.215-1.621-.048-.37.568-1.107 1.018-1.645.422-.504.875-.763 2.123-1.438a52.31 52.31 0 0 0 5.325-3.249c2.538-1.75 3.83-3.52 5.08-5.23.632-.864 1.23-1.683 2.001-2.527l.027.136c.504 2.592-.111 4.9-.312 5.546zM84.71 51.54c-.925-1.105-1.906-1.636-3.265-2.372-1.126-.61-2.67-1.445-4.965-3.027-1.99-1.373-2.986-2.737-4.14-4.316-.698-.956-1.42-1.945-2.403-3-.741-.798-2.12-2.28-3.904-1.847-2.055.499-2.517 2.88-2.74 4.023-.66 3.397.072 6.348.418 7.458.565 1.817 2.066 6.645 6.955 10.025 2.92 2.018 5.664 3.031 8.195 3.031a8.95 8.95 0 0 0 2.913-.48c1.032-.353 4.429-1.744 4.834-4.82.274-2.077-.981-3.578-1.898-4.674zm-1.991 4.162c-.07.532-1.224 1.282-2.215 1.62-2.049.702-4.609.007-7.607-2.066-3.776-2.61-4.942-6.36-5.44-7.962-.2-.645-.816-2.952-.312-5.545l.027-.137c.771.845 1.37 1.663 2 2.527 1.25 1.711 2.543 3.48 5.081 5.23 2.47 1.704 4.12 2.597 5.325 3.25 1.248.675 1.701.934 2.123 1.438.45.538 1.067 1.276 1.018 1.645zM67.006 68.017c-1.176-2.84-4.255-4.92-7.66-5.175-.517-.04-5.136-.279-7.797 3.296-1.077 1.447-1.59 3.575-1.522 6.323.063 2.585.621 4.022 1.212 5.543.374.965.799 2.057 1.191 3.698.341 1.422.576 2.896.802 4.322.552 3.472.989 6.214 2.8 7.51.807.577 1.633.867 2.462.867.161 0 .322-.01.484-.033.95-.13 1.8-.628 2.526-1.483 1.39-1.635 1.926-4.588 2.438-7.995.067-.447.129-.858.188-1.21.244-1.436.478-2.032.833-2.936.423-1.078.95-2.42 1.656-5.456 1.033-4.444.941-5.935.387-7.27zM62.797 74.4c-.64 2.756-1.09 3.901-1.486 4.911-.396 1.007-.737 1.877-1.048 3.712-.064.374-.13.81-.2 1.284-.25 1.663-.77 5.122-1.549 6.038-.016.02-.044.052-.074.084l-.107-.071c-.517-.493-.944-3.176-1.226-4.95-.228-1.43-.485-3.05-.862-4.62-.454-1.9-.95-3.177-1.349-4.203-.542-1.397-.9-2.32-.947-4.22-.043-1.772.229-3.188.747-3.885 1.191-1.6 3.436-1.731 4.14-1.731a3.3 3.3 0 0 1 .216.005c1.905.143 3.726 1.305 4.33 2.764.087.21.353.852-.585 4.882z" fill="#fff"/>
  </svg>;
}
